<template>
    <button @click="addToCartExisting(id)" class="btn btn-primary text-nowrap">Add to cart</button>
</template>

<script>
    import ProductCardMixin from "../mixins/ProductCardMixin";
    export default {
        name: "AddToCartOrderButton",
        props: ['id'],
        mixins: [
            ProductCardMixin,
        ],
    }
</script>
